import { render, staticRenderFns } from "./logis.vue?vue&type=template&id=4cb04e94&scoped=true"
import script from "./logis.vue?vue&type=script&lang=js"
export * from "./logis.vue?vue&type=script&lang=js"
import style0 from "./logis.vue?vue&type=style&index=0&id=4cb04e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb04e94",
  null
  
)

export default component.exports